export const BOOKED_MEETING_COUNT_FIELD = 'totalBookedMeeting'
export const SAVE_TO_CALENDAR_COUNT_FIELD = 'totalSavedToCalendar'
export const STATISTIC_PATH = 'booking-module/statistic'

export default {
  BOOKED_MEETING_COUNT_FIELD,
  SAVE_TO_CALENDAR_COUNT_FIELD,
  STATISTIC_PATH
}
